import { useUserSessionStore } from "stores/v2/userSessionStore";
import { BAGGAGE_APPLIANCE_ID_KEY, BAGGAGE_TEACHER_USERNAME_KEY } from "js/telemetry/constants";

type TelemetryHeaders = {
	baggage?: string;
};

export function telemetryHeaders(): TelemetryHeaders {
	let baggage = "";

	const applianceId = useUserSessionStore.getState().getActiveDevice();
	if (applianceId) {
		baggage += `${BAGGAGE_APPLIANCE_ID_KEY}=${applianceId},`;
	}

	const teacherUsername = useUserSessionStore.getState().getActiveUser();
	if (teacherUsername) {
		baggage += `${BAGGAGE_TEACHER_USERNAME_KEY}=${teacherUsername},`;
	}

	// remove the trailing comma
	if (baggage.length > 0) {
		baggage = baggage.slice(0, -1);
	}

	// its unclear whether empty header values are well supported everywhere, so we don't return an empty string for baggage
	if (baggage.length === 0) {
		return {};
	} else {
		return {
			baggage,
		};
	}
}
